export default "<span\n    v-tooltip=\"{\n        message: fullDatetime,\n        disabled: !isToday\n    }\"\n>{{ formattedRelativeTime }}</span>\n";